import React from 'react';
import Image from 'next/image';
import { SPORT_TABS, SportTabKey } from '../../utils/sportTabs';

interface CustomTabsProps {
  activeKey: string;
  onChange: (key: string) => void;
  className?: string;
  availableKeys?: SportTabKey[];
}

const CustomTabs: React.FC<CustomTabsProps> = ({
  activeKey,
  onChange,
  className = '',
  availableKeys,
}) => {
  const tabItems = availableKeys?.length
    ? SPORT_TABS.filter((tab) => availableKeys.includes(tab.key))
    : SPORT_TABS;

  return (
    <div className={`custom-tabs ${className}`}>
      <div className="custom-tabs-container">
        {tabItems.map((tab) => (
          <button
            key={tab.key}
            className={`custom-tab ${activeKey === tab.key ? 'active-tab' : ''}`}
            onClick={() => onChange(tab.key)}
            type="button"
            aria-label={tab.label}
          >
            <Image
              src={tab.icon}
              alt={tab.label}
              width={20}
              height={20}
              unoptimized
              className="tab-icon"
            />
            <span className="tab-label">{tab.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CustomTabs;
